import {useParams} from 'react-router-dom'
import React, { useState } from 'react';

//import {FlyReserveWithSearch} from '../containers'
//SJReserveWithSearch
import {SJReserveWithSearch} from '../containers'
function ShyReserveWithSearchPage() {
    console.log('sv****ShyReserveWithSearchPage')
    let { id,spaceKey } = useParams();
    console.log('sv****ShyReserveWithSearchPage',id,spaceKey )

    let svparams = { 'id': id, 'spaceKey':spaceKey}
    return (
        <SJReserveWithSearch svparams= {svparams} />
       
    );
}
export default ShyReserveWithSearchPage